import { render, staticRenderFns } from "./DuplicateTabView.vue?vue&type=template&id=13aef0f2&scoped=true&"
import script from "./DuplicateTabView.vue?vue&type=script&lang=js&"
export * from "./DuplicateTabView.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateTabView.vue?vue&type=style&index=0&id=13aef0f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13aef0f2",
  null
  
)

export default component.exports